// KpiTableComponent.tsx
import React, { useEffect } from "react";

interface DataTable {
  [key: string]: {
    interested: number | string;
    presentation: number | string;
    won: number | string;
  };
}

interface KpiTableComponentProps {
  dataTable: any;
  headers?: string[];
  headersVertical?: string[];
  rowColors?: string[];
  rowColorsData?: string[];
}

const KpiTableComponent: React.FC<KpiTableComponentProps> = ({
  dataTable,
  headers = [""],
  headersVertical = [""],
  rowColors = ["bg-gray-300"],
  rowColorsData = ["bg-gray-300"],
}) => {
  const maxLength = Math.max(
    ...Object.values(dataTable).map((arr) => arr.length)
  );

  const totalValidation = Object.keys(dataTable).map((key) => {
    return (key > "") ? 1 : 0;
  });

  return (
    <div className="kpi grid grid-cols-[1fr_2fr]">
      <div className="mt-9 ">
        <table className="table border-separate w-full text-left">
          <thead>
            <tr>
              {headers.length === 0 ? (
                <th className="text-primary-500 text-lg text-center pb-10 ">
                  KPI
                </th>
              ) : (
                headers.map((head, index) => (
                  <th
                    key={index}
                    //className="text-primary text-lg text-center pb-4"
                    className= {`text-primary-500 text-lg text-center ${totalValidation[0] == 1 ? 'pb-11' : 'pb-4'} `}
                  >
                    {head}
                  </th>
                ))
              )}
            </tr>
          </thead>
          <tbody className="">
            {headersVertical.map((head, index) => (
              <tr
                key={index}
                //className="border-4 border-white bg-[#D7C2FF] h-12 w-full"
                className={`border-4 border-white h-12 w-full  ${rowColors[index] || 'bg-gray-300'}`}
              >
                <td className="whitespace-nowrap overflow-hidden w-full pl-4 pr-5 text-ellipsis">
                  {head}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-9 overflow-x-auto ml-8 w-full pr-8">
        <table className="table border-separate [border-spacing:10px_2px] w-full">
          <thead>
            <tr className="">
              {Object.keys(dataTable).map((key) => {
                return (
                  <th
                    key={key}
                    className="text-primary-500 text-lg pb-3 text-center align-middle whitespace-nowrap overflow-hidden"
                  >
                    {key}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody id="data" className="">
            {Array.from({ length: maxLength }).map((_, rowIndex) => (
              <tr
                key={rowIndex}
                //className="border-4 border-white bg-[#D7C2FF] h-12 "
                className={`border-4 border-white h-12 w-full  ${rowColorsData[rowIndex] || 'bg-gray-300'}`}
              >
                {Object.keys(dataTable).map((key) => (
                  <td
                    key={key}
                    className="whitespace-nowrap overflow-hidden px-4 "
                  >
                    {dataTable[key][rowIndex] !== undefined
                      ? dataTable[key][rowIndex]
                      : ""}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default KpiTableComponent;
